import * as React from "react";
import { forwardRef } from "react";
const SvgCommunication = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M4 6.41025H28V25.7949H4V6.41025Z",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M4 8.74564L14.8092 17.8675C15.1423 18.1486 15.5641 18.3028 16 18.3028C16.4359 18.3028 16.8577 18.1486 17.1908 17.8675L28 8.74564",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgCommunication);
export default ForwardRef;
